"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKernelNamespace = void 0;
const ethers_1 = require("ethers");
const CORE_NAMESPACE = ethers_1.ethers.utils.solidityKeccak256(['string'], ['core']);
const APP_ADDR_NAMESPACE = ethers_1.ethers.utils.solidityKeccak256(['string'], ['app']);
const APP_BASES_NAMESPACE = ethers_1.ethers.utils.solidityKeccak256(['string'], ['base']);
const KERNEL_NAMESPACES_NAMES = new Map([
    [CORE_NAMESPACE, 'Core'],
    [APP_ADDR_NAMESPACE, 'Default apps'],
    [APP_BASES_NAMESPACE, 'App code'],
]);
function getKernelNamespace(hash) {
    return KERNEL_NAMESPACES_NAMES.has(hash)
        ? { name: KERNEL_NAMESPACES_NAMES.get(hash), hash }
        : null;
}
exports.getKernelNamespace = getKernelNamespace;
//# sourceMappingURL=kernel.js.map